import phl235PaperFile from '../assets/files/writing/phl235-paper.pdf';
import rlg211Paper1File from '../assets/files/writing/rlg211-paper-1.pdf';
import rlg211Paper2File from '../assets/files/writing/rlg211-paper-2.pdf';
import rlg211Paper3File from '../assets/files/writing/rlg211-paper-3.pdf';

import phl235PreviewImage from '../assets/images/writing/phl235-paper.png';
import rlg211Paper1PreviewImage from '../assets/images/writing/rlg211-paper-1.png';
import rlg211Paper2PreviewImage from '../assets/images/writing/rlg211-paper-2.png';
import rlg211Paper3PreviewImage from '../assets/images/writing/rlg211-paper-3.png';

export const writingItems = [
  {
    slug: 'hume-on-violations-of-the-laws-of-nature',
    title: 'Hume on Violations of the Laws of Nature',
    meta: 'PHL235',
    previewImage: phl235PreviewImage,
    previewAlt: 'First page preview of Hume on Violations of the Laws of Nature.',
    fileUrl: phl235PaperFile,
    fileName: 'phl235-paper.pdf',
    listDescription:
      "A philosophy paper on Hume's account of miracles, testimony, and violations of the laws of nature.",
    intro:
      "This article was written for PHL235. It examines Hume's account of miracles, testimony, and violations of the laws of nature. The full PDF is embedded below.",
  },
  {
    slug: 'rlg211-paper-1',
    title: 'On Methodology',
    meta: 'RLG211 / Paper 1',
    previewImage: rlg211Paper1PreviewImage,
    previewAlt: 'First page preview of RLG211 Paper 1.',
    fileUrl: rlg211Paper1File,
    fileName: 'rlg211-paper-1.pdf',
    listDescription:
      'An RLG211 paper on methodology in the study of religion, with a focus on Bruce Lincoln and Melford Spiro.',
    intro:
      'This article was written for RLG211. It focuses on methodology in the study of religion, especially around Bruce Lincoln and Melford Spiro. The full PDF is embedded below.',
  },
  {
    slug: 'rlg211-paper-2',
    title: 'Application of the Theses on Method',
    meta: 'RLG211 / Paper 2',
    previewImage: rlg211Paper2PreviewImage,
    previewAlt: 'First page preview of RLG211 Paper 2.',
    fileUrl: rlg211Paper2File,
    fileName: 'rlg211-paper-2.pdf',
    listDescription:
      "An RLG211 paper comparing Bruce Lincoln's Theses on Method with William James and Sigmund Freud.",
    intro:
      "This article was written for RLG211. It compares Bruce Lincoln's Theses on Method with work by William James and Sigmund Freud. The full PDF is embedded below.",
  },
  {
    slug: 'rlg211-paper-3',
    title: 'Interpreting Religious Experience',
    meta: 'RLG211 / Paper 3',
    previewImage: rlg211Paper3PreviewImage,
    previewAlt: 'First page preview of RLG211 Paper 3.',
    fileUrl: rlg211Paper3File,
    fileName: 'rlg211-paper-3.pdf',
    listDescription:
      'An RLG211 paper using Freud and Winnicott to interpret religious experience and Haizmanns visions.',
    intro:
      "This article was written for RLG211. It uses Freud and Winnicott to interpret religious experience and Haizmann's visions. The full PDF is embedded below.",
  },
];
